export * from "./AutoSlider" ;  
export * from "./functioning.styles" ;
export * from "./FunctioningCard" ;